import { combineReducers } from 'redux';
import FireBaseUserReducer from './firebase_user_reducer';
import Overlay from './ts_overlay';
import Map from './ts_map';
import Canvas from './ts_canvas';
import Stamp from './ts_stamp';
import Modal from './modal';
import UserData from './ts_userData';
import Active from './ts_active';
const rootReducer = combineReducers({
    currentUser: FireBaseUserReducer,
    map: Map,
    overlay:Overlay,
    modal: Modal,
    canvas: Canvas,
    stamp: Stamp,
    userData: UserData,
    active: Active
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/reducers/index.js